import { render, staticRenderFns } from "./VvFormMaskInput.vue?vue&type=template&id=662ffa8a&scoped=true&"
import script from "./VvFormMaskInput.vue?vue&type=script&lang=js&"
export * from "./VvFormMaskInput.vue?vue&type=script&lang=js&"
import style0 from "./VvFormMaskInput.vue?vue&type=style&index=0&id=662ffa8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662ffa8a",
  null
  
)

export default component.exports